const stylesheet = new CSSStyleSheet();stylesheet.replaceSync(`p {
  font-weight: bold;
}
`);export default stylesheet;